import React from 'react';
import { useTranslation } from 'react-i18next';
import { Divider, HtmlTrans, SectionHeader, Typography } from 'web-library';
import { Theme as AugmentedTheme } from '@mui/material';


import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) =>
({
  ul: {
    fontSize: '1.125rem',
  },
  a: {
    textDecoration: 'none',
    color: theme.color.link.linkDefault01,
  },
}));

const NonNationalInstruction = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <SectionHeader
        title={t('exam->>RegisterExamInstructions.Instructions for GCE-Level Examination(s)')}
      />

      <Typography variant="body1">
        <HtmlTrans
          i18nKey="exam->>RegisterExamInstructions.GceInstructionDetails"
          values={{
            ulClass: classes.ul,
          }}
        />
      </Typography>

      <Divider paddingTop />
      <SectionHeader title={t('exam->>RegisterExamInstructions.Introduction:')} />

      <Typography variant="body1">
        <HtmlTrans
          i18nKey="exam->>RegisterExamInstructions.IntroductionDetails"
          values={{
            ulClass: classes.ul,
            aClass: classes.a,
          }}
        />
      </Typography>
    </>
  );
};
export default NonNationalInstruction;
